import { RichTextField } from '@prismicio/types';

export const hasRichTextContent = (richText?: RichTextField[]): boolean => {
  return Array.isArray(richText) && !!richText.length;
};
